export const products = [
  {
    model: 'XB60',
    name: 'Spinning Bike',
    specs: 'Max user 150kg',
    weight: '60kg',
    volume: '0.35 CBM',
    price: 3725.76,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/0f89f3dc7c95aa013aa46a31bafc0d44.png'
  },
  {
    model: 'EB8000',
    name: 'Elliptical Machine',
    specs: 'Self-generating',
    weight: '200kg',
    volume: '2.50 CBM',
    price: 14551.55,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/14b188f2a3cf402b933a0c6b0c0f6190.png'
  },
  {
    model: 'TT-X6',
    name: 'Commercial Treadmill',
    specs: '',
    weight: '280kg',
    volume: '1.80 CBM',
    price: 13848.57,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/a126be9dad2675ade7150d67560ac32e.png'
  },
  {
    model: 'BF32',
    name: 'Lat Pulldown/Low Row',
    specs: 'Stack 96+4.6kg',
    weight: '260kg',
    volume: '1.80 CBM',
    price: 9630.73,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/27edc9e2a5af4602ee6529b213a01e13.png'
  },
  {
    model: 'BF33',
    name: 'Leg Curl/Leg Extension',
    specs: 'Stack 96+4.6kg',
    weight: '300kg',
    volume: '1.50 CBM',
    price: 9630.73,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/ad1ef133016ea8794d33c5c31b35dd9f.png'
  },
  {
    model: 'BF34',
    name: 'Abductor/Adductor',
    specs: 'Stack 96+4.6kg',
    weight: '240kg',
    volume: '1.50 CBM',
    price: 9630.73,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/f5d5d7a1f05f10dc8833ca7253b350c3.png'
  },
  {
    model: 'BH14',
    name: 'Leg Press',
    specs: 'Stack 96+4.6kg',
    weight: '296kg',
    volume: '1.80 CBM',
    price: 12442.63,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/79d7399af71ffdd7b1cfc47b7ca65e18.png'
  },
  {
    model: 'BH22',
    name: 'Functional Trainer',
    specs: 'Stack 96kg×2',
    weight: '420kg',
    volume: '1.50 CBM',
    price: 11458.46,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/4c5156d87e8c4db07aa8a53a8da601aa.png'
  },
  {
    model: 'BH23',
    name: 'Smith Machine',
    specs: '',
    weight: '200kg',
    volume: '1.50 CBM',
    price: 8787.17,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/33330078478f9af00f9e4b3e8c2feeb2.png'
  },
  {
    model: 'BH62',
    name: 'Multi-Jungle 4 Station',
    specs: '4 Station',
    weight: '',
    volume: '',
    price: 30016.96,
    image: 'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/edfb59f3e48c5dc91de90bca612a70b9.png'
  }
];